import { onMounted, onBeforeUnmount } from "vue";
import { useI18n } from "#imports";
import { onBeforeRouteLeave, useNuxtApp } from "#app";
export function useLeavePageWarning(shouldWarn) {
  const { t } = useI18n();
  const { $confirm } = useNuxtApp();
  onMounted(() => {
    window.addEventListener("beforeunload", handleBrowserNavigation);
  });
  onBeforeUnmount(() => {
    window.removeEventListener("beforeunload", handleBrowserNavigation);
  });
  onBeforeRouteLeave((to, from, next) => {
    if (shouldWarn.value) {
      $confirm({
        title: t("confirm.unsaved_changes.title"),
        text: t("confirm.unsaved_changes.message"),
        type: "warning"
      }).then(({ confirmed }) => {
        next(confirmed);
      });
    } else {
      next();
    }
  });
  function handleBrowserNavigation() {
    if (shouldWarn.value) {
      return t("confirm.unsaved_changes.message");
    }
    return null;
  }
}
